import styled from 'styled-components'
import { GroupTitle } from '../components'

export const BulkOrderSectionLabel = styled(GroupTitle)`
  font-size: 1.1rem;
  margin: 0 0 0.8rem 0;
`
